var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M15.354 6.646l4.942 4.94a.49.49 0 01.203.39.54.54 0 01-.003.084.488.488 0 01-.2.354l-4.942 4.94a.5.5 0 01-.708-.708l4.146-4.147L4 12.5c-.667 0-.667-1 0-1l14.792-.001-4.146-4.145a.5.5 0 01.708-.708z" })
  );
});